import {fetch} from "../../utils/dataAccess";
import {SubmissionError} from "redux-form";

export function resetPassword(token, values) {
    return dispatch => {
        dispatch(success(false));
        dispatch(error(null));
        dispatch(loading(true));
        return fetch(
            '/password-reset/{token}'.replace('{token}', token),
            { method: 'POST', data: values }
            ).then(response => {
                dispatch(loading(false));
                dispatch(success(response.data));
            })
            .catch(e => {
                dispatch(loading(false));
                if (e instanceof SubmissionError) {
                    dispatch(error(e.errors._error));
                    throw e;
                }

                dispatch(error(e.message));
            });
    };
}

export function error(error) {
    return { type: 'PASSWORD_RESET_ERROR', error };
}

export function loading(loading) {
    return { type: 'PASSWORD_RESET_LOADING', loading };
}

export function success(data) {
    return { type: 'PASSWORD_RESET_SUCCESS', data };
}

export function reset() {
    return dispatch => {
        dispatch(loading(false));
        dispatch(error(null));
        dispatch(success(false))
    };
}
